import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_AU_REPORT');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const getAuditCampaignRequest = createAction('AU_REPORT_GET_CAMPAIGN_REQUEST');
export const getAuditCampaignSuccess = createAction('AU_REPORT_GET_CAMPAIGN_SUCCESS');
export const getAuditCampaignError = createAction('AU_REPORT_GET_CAMPAIGN_ERROR');

export const getAuditCampaign = (id) => async (dispatch) => {
  try {
    dispatch(getAuditCampaignRequest());
    const resp = await instance.get(`/v1/ActivityCampaign/GetByActivityId/${id}`);
    
    dispatch(getAuditCampaignSuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getAuditCampaignError(e.response.data.description));
    else
      dispatch(getAuditCampaignError(e.message));
  }
};